import React, { useEffect, useState, useRef } from "react";

export default function CarouselDetail({ producto, setModalImage, setIsModalOpen }) {
    const imagenes = [...Array(12)]
        .map((_, i) => producto[`imagen${i + 1}`])
        .filter(Boolean);

    const [index, setIndex] = useState(0);
    const intervalRef = useRef(null);
    const pauseRef = useRef(false);

    // Autoplay estable
    useEffect(() => {
        if (imagenes.length === 0) return;

        intervalRef.current = setInterval(() => {
            if (!pauseRef.current) {
                setIndex((prev) => (prev + 1) % imagenes.length);
            }
        }, 2500);

        return () => clearInterval(intervalRef.current);
    }, [imagenes.length]);

    // Función para pausar autoplay en interacciones
    const pauseAutoplay = () => {
        pauseRef.current = true;
        setTimeout(() => (pauseRef.current = false), 4000); // 4s pausa
    };

    const next = () => {
        pauseAutoplay();
        setIndex((prev) => (prev + 1) % imagenes.length);
    };

    const prev = () => {
        pauseAutoplay();
        setIndex((prev) => (prev - 1 + imagenes.length) % imagenes.length);
    };

    if (imagenes.length === 0) return null;

    return (
        <div style={styles.container}>

            {/* Imagen */}
            <div style={styles.imageWrapper}>
                <img
                    src={imagenes[index]}
                    alt={producto.titulo}
                    style={styles.image}
                    onClick={() => {
                        pauseAutoplay();
                        setModalImage(imagenes[index]);
                        setIsModalOpen(true);
                    }}
                />
            </div>

            {/* Flecha izquierda */}
            <button style={{ ...styles.arrow, left: "10px" }} onClick={prev}>
                ‹
            </button>

            {/* Flecha derecha */}
            <button style={{ ...styles.arrow, right: "10px" }} onClick={next}>
                ›
            </button>

            {/* Indicadores */}
            <div style={styles.dots}>
                {imagenes.map((_, i) => (
                    <div
                        key={i}
                        onClick={() => {
                            pauseAutoplay();
                            setIndex(i);
                        }}
                        style={{
                            ...styles.dot
                        }}
                    />
                ))}
            </div>
        </div>
    );
}

/* --- ESTILOS --- */
const styles = {
    container: {
        position: "relative",
        width: "100%",
        maxWidth: "520px",
        margin: "30px auto 0",
        padding: "10px 0",
        userSelect: "none",
    },
    imageWrapper: {
        width: "100%",
        height: "320px",  
        overflow: "hidden",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f2f2f2",
    },
    image: {
        width: "100%",
        height: "100%",    
        objectFit: "cover",
        borderRadius: "10px",
        cursor: "pointer",
        transition: "opacity 0.4s ease-in-out",
    },
    arrow: {
        backgroundColor: "var(--color1)",
        position: "absolute",
        top: "50%",
        width: "40px",
        height: "40px",
        transform: "translateY(-50%)",
        background: "rgba(0,0,0,0.5)",
        border: "none",
        color: "#fff",
        cursor: "pointer",
        fontSize: "24px",
        padding: "5px 12px",
        borderRadius: "50%",
    },
    dots: {
        display: "flex",
        justifyContent: "center",
        marginTop: "10px",
        gap: "6px",
    },
    dot: {
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        cursor: "pointer",
    },
};